// ============================================================
// session-keepalive.ts  — ログインセッションの延命
// ============================================================
//
// 端末をスリープさせて復帰させると、ブラウザ (特に iOS Safari) は
// タブを破棄していることがあり、復帰後の最初の操作でログインが
// 切れているように見える。サーバー側のセッションは残っているため、
// 復帰直後に軽量なリクエストでセッションをタッチして有効期限を
// 延ばし、画面遷移なしで同じセッションに戻す。

const ENDPOINT = '/Session/Keepalive';
const INTERVAL = 5 * 60 * 1000;
// 復帰イベントは短時間に連続して飛ぶため、最小間隔を設ける。
const MIN_GAP = 30 * 1000;

let last = 0;
let sending = false;
let stopped = false;

// ログイン画面では叩かない (未認証の 401 を出さない)。
function signedIn(): boolean {
    return !!document.body?.dataset.ncUserCode;
}

async function touch(force = false): Promise<void> {
    const now = Date.now();
    if (stopped || sending || !signedIn() || (!force && now - last < MIN_GAP)) return;
    sending = true;
    last = now;
    try {
        const response = await fetch(ENDPOINT, {
            method: 'GET',
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        // セッションが失われていた場合は延命できないので以降は叩かない。
        // 自動遷移もしない (入力中の内容を失わせないため、次の操作時の
        // 通常のリダイレクトに任せる)。
        if (response.status === 401) stopped = true;
    } catch {
        // オフライン等は次回のタイミングで再試行する。
    } finally {
        sending = false;
    }
}

window.setInterval(() => {
    if (document.visibilityState === 'visible') void touch();
}, INTERVAL);

document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void touch();
});
window.addEventListener('pageshow', event => {
    // bfcache から復帰した場合は間隔を無視して即タッチする。
    void touch((event as PageTransitionEvent).persisted);
});
window.addEventListener('focus', () => { void touch(); });
window.addEventListener('online', () => { void touch(true); });
